import SidebarLoader from "./SidebarLoader";
import RenderMessage from "./RenderMessage";

// Regex to split messages and extract content
const messageWithContentRegex = /(<::>[\s\S]*?<::>)/;
const contentBetweenRegex = /<::>(.*?)<::>/;

export default function OrderedMessages(props) {
  const {
    message,
    index,
    error,
    isGenerating,
    getCurrentStepIndex,
    formatJsonConfigIfExist,
    Markdown,
    StepBlock,
    MessageGroup,
    MessageBubble,
    MarkdownContainer,
    isTtgUser,
  } = props;

  const { steps, content } = message ?? {};
  const splitedMessages = (content || "").split(messageWithContentRegex);

  // When we have steps (thinking/tool_use/status) but no content yet, render them so thinking is visible during streaming
  if (!content && !error && steps?.length) {
    const renderableSteps = steps.filter(
      (s) =>
        s.type === "thinking" || s.type === "tool_use" || s.type === "status"
    );
    if (renderableSteps.length > 0) {
      return (
        <MessageGroup>
          {renderableSteps.map((step) => {
            const stepIndex = steps.indexOf(step);
            const stepKey =
              step.type === "thinking"
                ? `thinking-${stepIndex}`
                : `${step.type}-${stepIndex}`;
            return (
              <MessageGroup isUser={false} key={stepKey}>
                <StepBlock
                  step={step}
                  index={stepIndex}
                  isGenerating={isGenerating}
                  currentStepIndex={getCurrentStepIndex(index, stepIndex)}
                />
              </MessageGroup>
            );
          })}
          <SidebarLoader />
        </MessageGroup>
      );
    }
  }

  // Show loader only when we have neither content nor steps
  if (!content && !error) {
    return (
      <MessageGroup>
        <SidebarLoader />
      </MessageGroup>
    );
  }

  // Render thinking steps first (they are never in content - avoid matching issues)
  const thinkingSteps = steps?.filter((s) => s.type === "thinking") ?? [];
  const contentChunks = splitedMessages.filter(Boolean);

  const thinkingBlocks =
    thinkingSteps.length > 0
      ? thinkingSteps.map((step) => {
          const stepIndex = steps.indexOf(step);
          return (
            <MessageGroup isUser={false} key={`thinking-${stepIndex}`}>
              <StepBlock
                step={step}
                index={stepIndex}
                isGenerating={isGenerating}
                currentStepIndex={getCurrentStepIndex(index, stepIndex)}
              />
            </MessageGroup>
          );
        })
      : [];

  const contentBlocks = contentChunks.map((msg, msgIndex) => {
    const text = msg.match(contentBetweenRegex)?.[1];
    const stepIndex = steps?.findIndex((step) => step.content === text);
    const step = steps?.[stepIndex];

    // Render step if it exists
    if (step) {
      return (
        <MessageGroup isUser={false} key={`step-${msgIndex}-${stepIndex}`}>
          <StepBlock
            step={step}
            index={stepIndex}
            isGenerating={isGenerating}
            currentStepIndex={getCurrentStepIndex(index, stepIndex)}
          />
        </MessageGroup>
      );
    }

    // Render normal message or config
    return (
      <RenderMessage
        key={`message-${msgIndex}-${stepIndex}`}
        msg={msg}
        index={index}
        msgIndex={msgIndex}
        isTtgUser={isTtgUser}
        Markdown={Markdown}
        MarkdownContainer={MarkdownContainer}
        MessageBubble={MessageBubble}
        formatJsonConfigIfExist={formatJsonConfigIfExist}
        MessageGroup={MessageGroup}
      />
    );
  });

  return [...thinkingBlocks, ...contentBlocks];
}
